<script>
    import ListItem from "./HelperComponents/ListItem.svelte";

    export let config;
    export let content;
    export let showDate;
    export let showAuthor;

</script>


<a href="/content/{content.urlname}-c-{content.cid}" class="link-no-change">
    <ListItem {config} {showDate} {showAuthor} listItemData={
        {
            id: content.cid,
            titel: content.cname,
            date: content.ctimestamp,
            author: content.cauthor,
            text: content.ctext.replace(/<[^>]*>?/gm, '').split(/\s+/).join(" "),
        }
    } />
</a>

<style>

    .link-no-change {
        color: inherit;
        text-decoration: inherit;
    }
</style>
